import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import axios from 'axios';

const STATUS = Object.freeze({
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
});

export const useStaffStore = defineStore('staff', () => {
  const requestStatus = ref(STATUS.INITIAL);

  const getIsReqInitial = computed(() => requestStatus.value === STATUS.INITIAL);
  const getIsReqError = computed(() => requestStatus.value === STATUS.ERROR);
  const getIsReqSuccess = computed(() => requestStatus.value === STATUS.SUCCESS);
  const getIsReqLoading = computed(() => requestStatus.value === STATUS.LOADING);
  const getReqStatus = computed(() => requestStatus.value);

  function setReqStatus(payload) {
    if (!payload || !STATUS[payload]) {
      console.error('Invalid requestStatus');
      return;
    }
    requestStatus.value = payload;
  }

  function initializeReqStatus() {
    requestStatus.value = STATUS.INITIAL;
  }

  async function sendContactEmail({ formData, writableApi }) {
    const { useMainStore } = await import('./mainStore.js');
    const mainStore = useMainStore();
    setReqStatus(STATUS.LOADING);
    const url = `${writableApi}api/v4/o/${mainStore.secondaryOrgId}/cms/staff_email`;
    try {
      const { email, fullName, message, member, recaptcha_response } = formData;
      await axios.post(url, {
        from_email: email,
        from_name: fullName,
        to_staff_id: member.id,
        body: message,
        'g-recaptcha-response': recaptcha_response,
      });

      setReqStatus(STATUS.SUCCESS);
    } catch (e) {
      console.error('There was an error making the request.. ', e);
      setReqStatus(STATUS.ERROR);
    }
  }

  return {
    requestStatus,
    getIsReqInitial,
    getIsReqError,
    getIsReqSuccess,
    getIsReqLoading,
    getReqStatus,
    setReqStatus,
    initializeReqStatus,
    sendContactEmail,
  };
});
